module.exports = __webpack_public_path__ + "img/support-ft.c15ffab0.svg";